import React, { useEffect, useMemo, useState } from "react";
import { useLang } from "../context/LangContext";
import { pickLang, t } from "../lib/i18n";
import { api } from "../lib/api";

const CATS = ["all", "concert", "club", "install", "event"];

export default function Portfolio() {
  const { lang } = useLang();
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/portfolio").then((r) => setItems(r.data)); }, []);
  const filtered = useMemo(() => cat === "all" ? items : items.filter(i => i.category === cat), [items, cat]);
  const labels = { all: { en: "All", gr: "Όλα" }, concert: { en: "Concert", gr: "Συναυλίες" }, club: { en: "Club", gr: "Clubs" }, install: { en: "Install", gr: "Εγκαταστάσεις" }, event: { en: "Event", gr: "Εκδηλώσεις" } };

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20" data-testid="portfolio-page">
      <div className="max-w-3xl">
        <div className="label-tag mb-4 slash">{t("sections.portfolio_eyebrow", lang)}</div>
        <h1 className="display-font text-5xl sm:text-7xl font-black uppercase leading-[0.9] tracking-tighter">
          {lang === "gr" ? <>Έργα <span className="neon-text">μας.</span></> : <>What we've <span className="neon-text">built.</span></>}
        </h1>
      </div>

      <div className="flex flex-wrap gap-2 mt-12 mb-10" data-testid="portfolio-filters">
        {CATS.map((c) => (
          <button key={c} onClick={() => setCat(c)} data-testid={`pf-cat-${c}`}
            className={`mono-font text-xs uppercase tracking-[0.2em] px-5 py-3 border transition-all ${
              cat === c ? "bg-[#ccff00] text-black border-[#ccff00]" : "border-[#2a2a35] text-gray-300 hover:border-[#ccff00]"
            }`}>
            {labels[c][lang] || labels[c].en}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((p, i) => (
          <div key={p.id} className="card-dark group overflow-hidden" data-testid={`portfolio-item-${i}`}>
            <div className="aspect-[4/3] overflow-hidden">
              <img src={p.image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="p-5">
              <div className="mono-font text-[10px] tracking-[0.25em] uppercase text-[#ccff00]">{p.client} · {p.year}</div>
              <h3 className="display-font text-xl font-bold mt-2">{pickLang(p.title, lang)}</h3>
              <p className="text-gray-400 text-sm mt-3 line-clamp-2">{pickLang(p.description, lang)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
